export const Permission = ({ children, roleKeycloack, func, id, user, visualizar, mpTJ, idMPTJ, ppcaam }) => {
    if (id && user) {
        if (roleKeycloack &&
            ((roleKeycloack.includes(func) ||
                ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) || (visualizar && roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar))) &&
                    user?.orgaoExterno?.includes(Number(id)))) || ((mpTJ && (roleKeycloack?.includes(servicoAcolhimentoFunc.visualizarParteTJ) || roleKeycloack?.includes(servicoAcolhimentoFunc.visualizarParteMP) || (ppcaam && roleKeycloack?.includes(servicoAcolhimentoFunc.visualizarPartePPCAAM)))) && (user?.orgaoExterno?.includes(Number(idMPTJ)) || user?.orgaos[0]?.id === idMPTJ)))) {
            return children
        } else {
            return null
        }

    } else {
        if (roleKeycloack && roleKeycloack.includes(func)) {
            return children
        } else if (func === "") {
            return children
        } else {
            return null
        }
    }
}

export const servicoAcolhimentoFunc = {
    cadastrar: "mca-func-servico_cadastrar",
    editar: "mca-func-servico_editar",
    pesquisar: "mca-func-servico_pesquisar",
    visualizar: "mca-func-servico_visualizar",
    //consultarFicha: "mca-func-servico_consultar_ficha",
    //visualizarFicha: "mca-func-servico_visualizar_ficha",

    visualizarAcolhedora: "mca-func-servico_acolhedora_visualizar",

    visualizarParteConsulente: "mca-func-consulente",
    visualizarPartePPCAAM: "mca-func-ppcaam",
    visualizarParteMP: "mca-func-mp",
    visualizarParteTJ: "mca-perfil-tribunal_justica",

    cadastrarRede: "mca-func-rede_cadastrar",
    editarRede: "mca-func-rede_editar",
    visualizarRede: "mca-func-rede_visualizar",
}

export const criancaFunc = {
    pesquisar: "mca-func-crianca_pesquisar",
    pesquisarRisco: 'mca-func-crianca-risco_pesquisar',

    cadastrar: "mca-func-crianca_cadastrar",
    cadastrarServico: 'mca-func-crianca-servico_cadastrar',

    editar: "mca-func-crianca_editar",
    visualizar: "mca-func-crianca_visualizar",
    visualizarTudo: "mca-func-gestor",
    visualizarTudoAcolhimento: "mca-func-acolhimento",
    visualizarTudoTutelar: "mca-func-tutelar",
    visualizarTudoDefensoria: "mca-func-defensoria",
    buscarFiliacao: "mca-func-crianca_buscar_filiacao",
    cadastrarEditarFiliacao: "mca-func-crianca_ce_filiacao",
    incluirDadosAcolhedor: "mca-func-crianca_dados_acolhedor",
    desligar: "mca-func-crianca_desligar",
    incluirEducacao: "mca-func-crianca_incluir_educacao",
    alterarEducacao: "mca-func-crianca_alterar_educacao",
    visualizarEducacao: "mca-func-crianca_visualizar_educacao",

    excluir: "mca-func-crianca_excluir",
    imprimir: "mca-func-crianca_imprimir",
    // visualizarBlocoJuridica: "mca-func-bloco-juridica_visualizar",
    // visualizarBlocoAnexos: "mca-func-bloco-anexos_visualizar",
    // visualizarBlocoMovimentacao: "mca-func-bloco-movimentacao_visualizar",
    visualizarJuridica: "mca-func-juridica_visualizar",

    cadastrarPP: "mca-func-pp_cadastrar",
    editarPP: "mca-func-pp_editar",
    visualizarPP: "mca-func-pp_visualizar",
    excluirPP: "mca-func-pp_excluir",

    cadastrarVoluntaria: "mca-func-voluntaria_cadastrar",
    editarVoluntaria: "mca-func-voluntaria_editar",
    excluirVoluntaria: "mca-func-voluntaria_excluir",

    editarAdocao: "mca-func-adocao_editar",

    escolarExcluir: "mca-func-escolar_excluir",

    visualizarSaude: "mca-func-crianca_visualizar_saude",
    cadastrarSaude: "mca-func-crianca_cadastrar_saude",
    editarSaude: "mca-func-crianca_editar_saude",

    cadastrarProfissionalizacao: "mca-func-crianca_cadastrar_profissionalizacao",
    editarProfissionalizacao: "mca-func-crianca_editar_profissionalizacao",
    visualizarProfissionalizacao: "mca-func-crianca_visualizar_profissionalizacao",

    visualizarAcolhido: "mca-func-crianca-acolhido_visualizar",

    apadrinhamentoCadastrar: "mca-func-apadrinhamento_cadastrar",
    apadrinhamentoEditar: "mca-func-apadrinhamento_editar",
    apadrinhamentoVisualizar: "mca-func-apadrinhamento_visualizar",
    apadrinhamentoHistoricoVisualizar: "mca-func-apadrinhamento-historico_visualizar",

    pendenciasImprimir: "mca-func-pendencias_imprimir",
    pendenciasExportar: "mca-func-pendencias_exportar",
    pendenciasVisualizar: "mca-func-pendencias_visualizar",
}

export const ocorrenciasFunc = {
    incluir: "mca-func-ocorrencia_incluir",
    alterar: "mca-func-ocorrencia_alterar",
    visualizar: "mca-func-ocorrencia_visualizar",
    excluir: "mca-func-ocorrencia_excluir",
}

export const referenciaFunc = {
    referenciaIncluir: "mca-func-referencia_incluir",
    referenciaAlterar: "mca-func-referencia_alterar",
    referenciaVisualizarDetalhe: "mca-func-referencia_visualizar_detalhe",
    referenciaVisualizar: "mca-func-referencia_visualizar",
    referenciaExcluir: "mca-func-referencia_excluir",
    guardaIncluir: "mca-func-guarda_incluir",
    guardaAlterar: "mca-func-guarda_alterar",
    guardaExcluir: "mca-func-guarda_excluir",
    guardaAnexar: "mca-func-guarda_anexar",
    irmaoIncluir: "mca-func-irmao_cadastrar",
    irmaoAlterar: "mca-func-irmao_editar",
    irmaoExcluir: "mca-func-irmao_excluir",
}

export const motivoFunc = {
    motivoVisualizar: "mca-func-motivo_visualizar",
    motivoConsultar: "mca-func-motivo_consultar",
    motivoCadastrar: "mca-func-motivo_cadastrar",
    motivoEditar: "mca-func-motivo_editar",
    motivoInativar: "mca-func-motivo_inativar",
    motivoReativar: "mca-func-motivo_reativar",

    motivoSituacaoConsultar: "mca-func-motivo-situacao_consultar",
    motivoSituacaoCadastrar: "mca-func-motivo-situacao_cadastrar",
    motivoSituacaoEditar: "mca-func-motivo-situacao_editar",
    motivoSituacaoVisualizar: "mca-func-motivo-situacao_visualizar",
    motivoSituacaoInativar: "mca-func-motivo-situacao_inativar",
    motivoSituacaoReativar: "mca-func-motivo-situacao_reativar",
}

export const visitasFunc = {
    visitaConsultar: "mca-func-visita_consultar",
    visitaCadastrar: "mca-func-visita_cadastrar",
    visitaEditar: "mca-func-visita_editar",
    visitaVisualizar: "mca-func-visita_visualizar",
    visitaExcluir: "mca-func-visita_excluir",

    visitaServVisualizar: "mca-func-visita-serv_visualizar",
    visitaTipoConsultar: "mca-func-visita-tipo_consultar",
    //visitaAdolecenteEditar: "mca-func-visita-adolescente_editar",
    visitaCarregarCrianca: "mca-func-visita-crianca_carregar",
    visitaCriancaDpCadastrar: "mca-func-visita-crianca-dp_cadastrar"
}

export const vrCriancaFunc = {
    visitaCriancaCadastrar: "mca-func-visita-crianca_cadastrar",
    visitaCriancaVisualizar: "mca-func-visita-crianca_visualizar",
    restricaoCadastrar: "mca-func-restricao_cadastrar",
    restricaoEditar: "mca-func-restricao_editar",
    restricaoLiberar: "mca-func-restricao_liberar",
    restricaoExcluir: "mca-func-restricao_excluir",

    documentacaoCadastrar: "mca-func-documentacao_cadastrar",
    documentacaoEditar: "mca-func-documentacao_editar",
    documentacaoVisualizar: "mca-func-documentacao_visualizar",

    movimentoIntercalado: "mca-func-movimento_intercalar",
    movimentoVisualizar: "mca-func-movimento_visualizar",
    movimentoCadastrar: "mca-func-movimento_cadastrar",
    movimentoEditar: "mca-func-movimento_editar",
    movimentoExcluir: "mca-func-movimento_excluir",
    movimentoAcolhimentoCadastrar: "mca-func-movimento-acolhimento_cadastrar",
    movimentoDesligamentoCadastrar: "mca-func-movimento-desligamento_cadastrar",
    movimentoTransferenciaEntradaCadastrar: "mca-func-movimento-transferencia-entrada_cadastrar",
    movimentoTransferenciaSaidaCadastrar: "mca-func-movimento-transferencia-saida_cadastrar",
    movimentoTransferenciaFamiliarCadastrar: "mca-func-movimento-transferencia-familiar_cadastrar",
}

export const servicos = {
    perfilVisualizar: "mca-func-perfil_visualizar",
    perfilCadastrar: "mca-func-perfil_cadastrar",
    perfilEditar: "mca-func-perfil_editar",

    voluntariadoVisualizar: "mca-func-voluntariado_visualizar",
    voluntariadoCadastrar: "mca-func-voluntariado_cadastrar",
    voluntariadoEditar: "mca-func-voluntariado_editar",
    voluntariadoDesligar: "mca-func-voluntariado_desligar",

    gestaoCadastrar: "mca-func-gestao_cadastrar",
    gestaoEditar: "mca-func-gestao_editar",
    gestaoVisualizar: "mca-func-gestao_visualizar",

    regularidadeCadastrar: "mca-func-regularidade_cadastrar",
    regularidadeEditar: "mca-func-regularidade_editar",
    regularidadeVisualizar: "mca-func-regularidade_visualizar",

    planejamentoCadastrar: "mca-func-planejamento_cadastrar",
    planejamentoEditar: "mca-func-planejamento_editar",
    planejamentoVisualizar: "mca-func-planejamento_visualizar",

    equipeCadastrar: "mca-func-equipe_cadastrar",
    equipeEditar: "mca-func-equipe_editar",
    equipeVisualizar: "mca-func-equipe_visualizar",
    equipeDesligar: "mca-func-equipe_desligar",

    cumprimentoCadastrar: "mca-func-cumprimento_cadastrar",
    cumprimentoEditar: "mca-func-cumprimento_editar",
    cumprimentoVisualizar: "mca-func-cumprimento_visualizar",
    cumprimentoDesligar: "mca-func-cumprimento_desligar",

    servicoVisitaCrianca: "mca-func-crianca_visita_servico",
    servicoNoImprimir: "mca-func-servico-no_imprimir",

    tipoServicoConsultar: "mca-func-tipo-servico_consultar",
    tipoServicoCadastrar: "mca-func-tipo-servico_cadastrar",
    tipoServicoEditar: "mca-func-tipo-servico_editar",
    tipoServicoVisualizar: "mca-func-tipo-servico_visualizar",
    tipoServicoInativar: "mca-func-tipo-servico_inativar",
    tipoServicoReativar: "mca-func-tipo-servico_reativar",
}

export const situacaoJuridica = {
    promotoriaEditar: "mca-func-promotoria_editar",
    promotoriaEditarConcorrente: "mca-func-promotoria_concorrente",
    promotoriaJustificativa: "mca-func-justificativa-promotoria_visualizar",
    promotoriaReativar: "mca-func-promotoria_reativar",
    varaEditar: "mca-func-vara_editar",
    varaJustificativa: "mca-func-justificativa-vara_visualizar",
    varaReativar: "mca-func-vara_reativar",

    servicoPromotoriaBuscar: "mca-func-servico-promotoria_buscar",

    //servicoImprimir: "mca-func-servico_imprimir"
    situacaoJuridicaConsultar: "mca-func-situacao-juritica_consultar",
    situacaoJuridicaCadastrar: "mca-func-situacao-juritica_cadastrar",
    situacaoJuridicaEditar: "mca-func-situacao-juritica_editar",
    situacaoJuridicaVisualizar: "mca-func-situacao-juritica_visualizar",
    situacaoJuridicaInativar: "mca-func-situacao-juritica_inativar",
    situacaoJuridicaReativar: "mca-func-situacao-juritica_reativar",

}

export const anexosFunc = {
    abaAnexoRedirecionar: "mca-func-anexo-aba_redirecionar",
    abaAnexoAutorRedirecionar: "mca-func-anexo-aba-autor_redirecionar",

    anexoServicoVisualizar: "mca-func-servico-anexo_visualizar",
    anexoServicoVisualizarRestricao: "mca-func-servico-anexo-restricao_visualizar",
}

export const doencaFunc = {
    doencaConsultar: "mca-func-doenca_consultar",
    doencaCadastrar: "mca-func-doenca_cadastrar",
    doencaEditar: "mca-func-doenca_editar",
    doencaVisualizar: "mca-func-doenca_visualizar",
    doencaInativar: "mca-func-doenca_inativar",
    doencaReativar: "mca-func-doenca_reativar",
}
